import { createBrowserHistory } from 'history'

import { getFullBasenamePath } from './helpers/url-domain'

export default createBrowserHistory({
    basename: getFullBasenamePath(),
})
